<template>
  <div>
    <img v-if="qrUrl != ''" :src="qrUrl" :alt="code"/>
    <div v-html="code"></div>
  </div>
  </template>
<script>
import { mapMutations } from 'vuex';
import QRCode from 'qrcode';
  export default {
    props:["code", "label"],
    data: () => ({
      qrUrl: '',
    }),
    mounted(){
      this.generateQRCode();
    },
    watch:{
      code(value) {
        this.generateQRCode();
      }
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      generateQRCode() {
        if (this.code) {
          const [credId1, credId2, seat] = this.label.split("-");
          const otpLabel = `AlisonCloud: ${credId1}-${credId2}|${seat}`;
          const otpUri = `otpauth://totp/${otpLabel}:${encodeURIComponent(this.code)}?secret=${encodeURIComponent(this.code)}`;
            QRCode.toDataURL(otpUri, (error, url) => {
            if (error) {
              console.error('QR generation error:', error);
            } else {
              this.qrUrl = url;
            }
          });
        }
      },
    },
  }
</script>